import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { recipientKeys } from '../queries/keys';
import { recipientPaths } from '../queries/paths';

// TSS vite/03 — mutaciones de receptora del cliente (public-recipients.md,
// Q-121). Entran DIRECTAS al SoT (entidad liviana). El READ de lista vive en
// contexts/recipients.jsx; estas son las escrituras. Patrón canónico:
// useMutation + invalidateQueries(recipientKeys.all) → la lista se refresca.
//
// Escrituras devuelven OBJETO PLANO client-safe { id, number, name, farm, status }
// (sin envelope) → r.data directo. CSRF lo pone el api client. NUNCA se envía
// client_id/animal_id (el backend los fuerza/ignora). Errores → ApiError:
// 422 { fields:{farm_id} } finca ajena, 409 { fields } número duplicado por
// finca, 404 receptora fuera de la huella, 400 { fields }.
//
// TODO(deuda): tras el write también quedan stale los agregados recipients_kpi
// e informes (GET public/stats). Esta tarea invalida solo la lista de
// receptoras; la invalidación de esos agregados es deuda separada (D-004
// §Fuera de alcance) — cablear cuando se defina su queryKey en la feature
// `informes`.

export function useCreateRecipient() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(recipientPaths.create(), payload).then((r) => r.data),
        onSuccess: () => qc.invalidateQueries({ queryKey: recipientKeys.all }),
    });
}

export function useUpdateRecipient(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(recipientPaths.update(id), payload).then((r) => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: recipientKeys.detail(id) });
            qc.invalidateQueries({ queryKey: recipientKeys.all });
        },
    });
}

export function useDeleteRecipient() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(recipientPaths.remove(id)).then((r) => r.data),
        onSuccess: () => qc.invalidateQueries({ queryKey: recipientKeys.all }),
    });
}
